import React, { ReactElement, Component, FC } from 'react';
import { CSSTransition } from 'react-transition-group';
import './withAnimation.modules.scss';

export interface CloseAnimation {
  (): void;
}

export interface withAnimationProps {
  children: ReactElement;
  fade?: boolean;
  minimize?: boolean;
  unmount?: boolean;
}

export interface withAnimationState {
  isShowing: boolean;
}

const withAnimation = (AnimatedComponent: FC): typeof Component => {
  return class WithAnimation extends Component<
    withAnimationProps,
    withAnimationState
  > {
    constructor(props: withAnimationProps) {
      super(props);
      this.state = {
        isShowing: true,
      };
    }

    getClassName = ({
      fade,
      minimize,
    }: {
      fade: boolean;
      minimize: boolean;
    }) => {
      if (fade) return 'oneui__animation--fade';
      if (minimize) return 'oneui__animation--minimize';
      if (fade && minimize) return 'oneui__animation--fade-minimize';

      return '';
    };

    closeAnimation = () => {
      this.setState({ isShowing: false });
    };

    render() {
      const { unmount, fade, minimize, ...rest } = this.props;
      const { isShowing } = this.state;
      const props = { ...rest, closeAnimation: this.closeAnimation };

      return (
        <CSSTransition
          in={isShowing}
          timeout={300}
          classNames={this.getClassName({ fade, minimize })}
          unmountOnExit={unmount}
        >
          <div>
            <AnimatedComponent {...props} />
          </div>
        </CSSTransition>
      );
    }
  };
};

export default withAnimation;
